export default {
  Main: {
    service: 'SERVICES',
    work: 'WORKS',
    location: 'LOCATION',
    home: 'HOME',
  },
  Headers: {
    description:
      'The best to clean your pools! No more weird colors and unwanted objects, just great relaxing blue water.',
    cta: 'Contact us',
  },
  Services: {
    title: 'Services',
    spa: {
      title: 'SPA Services',
      description: 'Cleaning and Water maintenance in pool',
    },
    treatment: {
      title: 'Treatmen',
      description: 'Pear remove green alge and black alge',
    },
    acid: {
      title: 'Acid Treatment',
      description: 'Brushing and rinsing with water and acid',
    },
    salt: {
      title: 'Salt System',
      description: 'Water treatment salt control and cleaning of salt system',
    },
    blacksmith: {
      title: 'Sales of Blacksmith',
      description: 'Equipment, filter, engine and salt system',
    },
    installation: {
      title: 'Installation',
      description: 'Filter, engine, farrier, and salt system',
    },
    repair: {
      title: 'Repair',
      description: 'Filter, blacksmith repair, electric light repair, vacuum cleaner motor repair and salt system',
    },
  },
  Works: {
    title: 'Works',
    before: 'Before',
    after: 'After',
  },
  Location: {
    title: 'Location',
  },
  Footer: {
    description: 'You can count on us',
    footer: 'All rights reserved',
  },
}
